import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {DcpOrderEntryService} from '@app/services/dcp-order-entry.service';
import {OrderEntry} from '@spartacus/cart/base/root';
import {TranslatePipe} from '@spartacus/core';

@Component({
  selector: 'dcp-derivative-entry-list',
  templateUrl: './derivative-entry-list.component.html',
  imports: [TranslatePipe],
})
export class DerivativeEntryListComponent {
  private _derivativeEntries: OrderEntry[];

  @Input()
  set derivativeEntries(value: OrderEntry[]) {
    this._derivativeEntries = value;
    this.cdr.detectChanges();
  }

  get derivativeEntries(): OrderEntry[] {
    return [...new Map((this._derivativeEntries ?? []).map((x) => [x.entryNumber, x])).values()];
  }

  constructor(
    public cdr: ChangeDetectorRef,
    public dcpOrderEntryService: DcpOrderEntryService,
  ) {}
}
